import React, { memo, useContext, useState } from "react";
import { Button, Col, Modal, Row, ListGroup, Spinner } from "react-bootstrap";
import { ChatContext } from 'context/Context';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import SimpleBarReact from 'simplebar-react';
import { reportChatById } from "services/elvis";
import { toast } from "react-toastify";

const ReportModal = () => {
    const [loading, setLoading] = useState(false);
    const { showReportModal, setShowReportModal, reportChat, setReportChat } = useContext(ChatContext);
    console.log(reportChat)
    const close = () => {
        setShowReportModal(false);
        setReportChat(null);
    }

    const handleSubmit = async id => {
        if (!id) {
            toast.warning("No ID found for the selected chat! Please try again.");
            return;
        }
        setLoading(true);
        try {
            const res = await reportChatById(id);
            console.log(res);
            res.success ? toast.success("Chat has been reported! Thank you.") :
                toast.error("Something went wrong! " + res.message || "");
        } catch (err) {
            console.log(err)
            toast.error(err);
        } finally {
            setLoading(false);
            close();
        }
    }

    return (
        <Modal
            show={showReportModal}
            onHide={close}
            dialogClassName='w-50'
            centered>
            <Modal.Header closeButton>
                <Modal.Title>Report Chat</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className="gap-0 align-items-stretch">
                    <Col sm={6} className="pe-0 d-flex">
                        <div className="bg-100 border border-300 p-2 flex-grow-1 d-flex flex-column">
                            <h5 className="text-600 mb-2">You Are Reporting</h5>
                            <div className="flex-grow-1 d-flex align-items-center">
                                <div
                                    className="w-100 border-start border-4 ps-1 d-flex align-items-center"
                                    style={{ height: '300px' }}>
                                    <SimpleBarReact className="w-100" style={{ maxHeight: '100%' }}>
                                        <div className="text-600 py-3 pe-3">
                                            {reportChat?.message || "No message found!"}
                                        </div>
                                    </SimpleBarReact>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col sm={6} className="ps-0 d-flex">
                        <div className="border border-300 p-2 flex-grow-1">
                            <h5 className="text-600 mb-2">What Happens</h5>
                            <ListGroup variant="flush">
                                <ListGroup.Item><FontAwesomeIcon size="sm" icon={faCircle} className="text-primary" /> The technical team will review your question and answer as soon as they can.</ListGroup.Item>
                                <ListGroup.Item><FontAwesomeIcon size="sm" icon={faCircle} className="text-primary" /> If nessessary, they will get in touch to let you know of the outcome.</ListGroup.Item>
                                <ListGroup.Item><FontAwesomeIcon size="sm" icon={faCircle} className="text-primary" /> Nothing else will change, your chat will stay the same.</ListGroup.Item>
                            </ListGroup>
                        </div>
                    </Col>
                </Row>
                <p className="fw-bolder mt-3 mb-0">Are you sure you want to continue?</p>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={loading}
                    variant="outline-primary"
                    onClick={() => handleSubmit(reportChat?.id)}>
                    {loading ? <Spinner variant="primary" size="sm" /> : 'Confirm'}
                </Button>
                <Button disabled={loading} variant="outline-danger" onClick={close}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default memo(ReportModal);